// removed by extract-text-webpack-plugin
module.exports = {"mastheadNavLink":"src-components-Masthead-MastheadNavLink----MastheadNavLink-module---mastheadNavLink---2v8Xt","active":"src-components-Masthead-MastheadNavLink----MastheadNavLink-module---active---2dItO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Masthead/MastheadNavLink/MastheadNavLink.module.scss
// module id = 270
// module chunks = 22676092666560